import PropTypes, { object } from 'prop-types';
import React from 'react';
import { withStyles, createMuiTheme, MuiThemeProvider } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import { compact, find, get, each, debounce, map, isEmpty, flowRight } from 'lodash';
import { injectIntl } from 'react-intl';
import Button from '@material-ui/core/Button';
import moment from 'moment';
import { withSnackbar } from 'notistack';
import { graphql, ApolloConsumer } from 'react-apollo';
import qs from 'query-string';
import InventoryUserDrawer from '../InventoryUserDrawer/InventoryUserDrawer';
import NewFormDialog from './InventoryUserNewFormDialog';
import InventoryUserMakeManagerDialog from './InventoryUserMakeManagerDialog';
import InventoryUserHideUserDialog from './InventoryUserHideUserDialog';
import InventoryUserObfuscateUserDialog from './InventoryUserObfuscateUserDialog';
import InventoryUserAssignAsLimitedAccess from './InventoryUserAssignAsLimitedAccess';
import InventoryUserResendActivationEmail from './InventoryUserResendActivationEmail';
import InventoryUserOmitFromMkt from './InventoryUserOmitFromMkt';
import InventoryUserSendEmailDialog from './InventoryUserSendEmailDialog';
import AddToSequenceDialog from '../EmailPlatform/AddToSequenceDialog';
import LoadCard from './LoadCard';
import SavedFilterSetSelector from './SavedFilterSetSelector';
import FBTable from '../FBTable/FBTable';
import { HomeOfficeQuery, InventoryUserQuery, UpdateCurrentUserColumns } from './InventoryUserQueries';
import ExportToCSVButton from './ExportToCSVButton';

const tableTheme = createMuiTheme({
  overrides : {
    MUIDataTable : {
      responsiveScroll : {
        minHeight : '100%',
        maxHeight : '100%',
      },
    },
  },
});

class InventoryUsers extends React.Component {
  constructor (props) {
    super(props);

    this.state = {
      inviteDialogOpen : false,
      inviteeId        : '',
      inviteeName      : '',
      resend           : false,
      page             : 0,
      count            : 0,
      openSnackBar     : false,
      filterParams     : {},
      compactedList    : {},
    };

    this.changePage = debounce(this.changePage, 300);
  }

  updateModifiedEmails = (inventory_users, putInventoryUser) => {
    this.modifiedList(inventory_users).map(a => putInventoryUser(a));
  };

  changePage = (page, refetch, rowsPerPage, orderHash, filter, searchText, compactedList, distanceSearchInput = null, distanceWithinInput = null) => {
    const { filterParams } = this.state;
    let compactFilter;
    if (isEmpty(compactedList)) {
      compactFilter = filterParams;
    } else {
      compactFilter = compactedList;
    }
    const { inventory_users, loadInventoryUserList } = this.props;
    const rows = rowsPerPage || inventory_users.rowsPerPage;
    const ord = orderHash || {
      orderBy : inventory_users.orderBy,
      order   : inventory_users.order,
    };
    const filterList = filter || inventory_users.filterList;

    const nameSearch = searchText || inventory_users.nameSearch;
    let name = nameSearch || null;
    if (name === '####NONE####') {
      name = null;
    }

    let distanceSearch = distanceSearchInput || inventory_users.distanceSearch;
    if (distanceSearch === '####NONE####') {
      distanceSearch = null;
    }

    let distanceWithin = distanceWithinInput || inventory_users.distanceWithin;
    if (distanceWithin === '####NONE####') {
      distanceWithin = null;
    }

    let tgFilter = null;
    if (!isEmpty(filterList.transition_goals) && filterList.transition_goals.includes('None')) {
      delete compactFilter.user_transition_goals_name;
      tgFilter = 'None';
    }
    let tagFilter = null;
    if (!isEmpty(filterList.iu_tags) && filterList.iu_tags.includes('None')) {
      delete compactFilter.iu_tags_name;
      tagFilter = 'None';
    }

    refetch({
      limit      : rows,
      offset     : page * rows,
      ...ord,
      filterList : compactFilter,
      nameSearch : name,
      distanceSearch,
      distanceWithin,
      tgFilter,
      tagFilter,
    }).then(response => {
      if (response.data && response.data.getInventoryUsers) {
        loadInventoryUserList({
          data        : response.data.getInventoryUsers,
          page,
          rowsPerPage : rows,
          orderBy     : ord.orderBy,
          order       : ord.order,
          filterList,
          nameSearch  : name,
          distanceSearch,
          distanceWithin,
          count       : response.data.getInventoryUserCount || 0,
        });
        this.setState({compactedList: compactFilter});
      }
    }).catch(err => {
      console.error('refetch error:', err);
    });
  };

  rowClick = async (event, user, client) => {
    const { updateSelectedInventoryUser, updateUser } = this.props;
    switch (event.target.innerText) {
      case 'Joined':
        break;
      case 'INVITE':
        break;
      case 'PENDING':
        break;
      case 'Activated':
        break;
      case 'CANCEL':
        break;
      default:
        if ([ 'TD', 'SPAN' ].includes(event.target.tagName)) {
          const result = await client.query({
            query       : InventoryUserQuery,
            variables   : { id: user.id },
            fetchPolicy : 'network-only',
          });
          updateSelectedInventoryUser({
            user : get(result, 'data.getInventoryUser'),
          });
          updateUser(get(result, 'data.getInventoryUser.user'));
        }
    }
  };

  changeRowsPerPage = numberOfRows => {
    const { inventory_users, refetch } = this.props;
    this.changePage(inventory_users.page, refetch, numberOfRows);
  };

  // onFilterChange = (changedColumn, value) => {
  //   const { inventory_users, loadInventoryUserList, refetch } = this.props;
  //   let { filterList } = inventory_users;

  //   filterList[changedColumn.id] = value;

  //   this.changePage(inventory_users.page, refetch, null, null, filterList);
  // };

  onFilterChange = (changedColumn, value) => {
    const { inventory_users, fb_columns, loadInventoryUserList, refetch } = this.props;
    const allColumns = fb_columns(this.props);
    const { filterList } = inventory_users;
    const list = filterList || [];
    const compactedList = {};
    list[changedColumn.id] = value;
    map(list, (v, k) => {
      const column = allColumns.find(f => f.id === k);
      const ransack_filter = get(column, 'ransack_filter');
      const filterType = get(column, 'filterType', '');
      if (filterType === 'email_conditions') {
        if (v && v.conditions && v.conditions.length > 0) {
          const validConditions = v.conditions.filter(c => c.value && c.value.trim() !== '');
          if (validConditions.length > 0) {
            compactedList['email_conditions'] = validConditions.map(c => ({
              operator: c.operator,
              value: c.value,
            }));
            compactedList['email_conditions_mode'] = v.mode || 'and';
          }
        }
        return v;
      }
      if (ransack_filter && (v || []).length > 0) {
        if (filterType === 'range') {
          if (v[0]) {
            compactedList[ransack_filter] = {
              ...compactedList[ransack_filter],
              gte : v[0],
            };
          }
          if (v[1]) {
            compactedList[ransack_filter] = {
              ...compactedList[ransack_filter],
              lte : v[1],
            };
          }
          return v;
        } else if (filterType === 'date') {
          if (v[0]) {
            compactedList[ransack_filter] = {
              ...compactedList[ransack_filter],
              lte : moment().subtract(v[0], 'year').format('YYYY-MM-DD'),
            };
          }
          if (v[1]) {
            compactedList[ransack_filter] = {
              ...compactedList[ransack_filter],
              gte : moment().subtract(v[1], 'year').format('YYYY-MM-DD'),
            };
          }
          return v;
        } else if (filterType === 'manager') {
          compactedList[ransack_filter] = v.map(i => i.id);
          return v;
        } else if (filterType === 'text') {
          compactedList[ransack_filter] = { 
            ...compactedList[ransack_filter],
            like: v 
          };
          return v;
        } else if (filterType === 'text_not') {
          compactedList[ransack_filter] = { 
            ...compactedList[ransack_filter],
            notLike: v 
          };
          return v;
        } else if (filterType === 'multiselect_text') {
          compactedList[ransack_filter] = { 
            ...compactedList[ransack_filter],
            not: v 
          };
          return v;
        } else if (filterType === 'user_email_exclude') {
          // Extract email values from selected user objects
          const emails = Array.isArray(v) ? v.map(item => item.email || item.value || item) : [];
          if (emails.length > 0) {
            compactedList[ransack_filter] = { 
              ...compactedList[ransack_filter],
              not: emails 
            };
          }
          return v;
        }

        return (compactedList[ransack_filter] = v);
      }
      return null;
    });
    this.changePage(inventory_users.page, refetch, null, null, list, null, compactedList);
    this.setState({ filterParams: compactedList });
  };

  onSort = (event, property) => {
    const { inventory_users, refetch } = this.props;
    let newOrder = 'desc';

    if (inventory_users.orderBy === property && inventory_users.order === 'desc') {
      newOrder = 'asc';
    }

    this.changePage(inventory_users.page, refetch, null, {
      orderBy : property,
      order   : newOrder,
    });
  };

  onSearchChange = value => {
    const { inventory_users, refetch } = this.props;
    let searchText = '####NONE####';
    if (value && value !== '') {
      searchText = value;
    }
    this.changePage(inventory_users.page, refetch, null, null, null, searchText);
  };
  
  onDistanceSearch = ({distanceSearch, distanceWithin}) => {
    const { inventory_users, refetch } = this.props;
    this.changePage(inventory_users.page, refetch, null, null, null, null, null, distanceSearch, distanceWithin);
  };

  handleApplyFilterSet = (savedFilters) => {
    const { inventory_users, refetch, loadInventoryUserList, fb_columns, filterColumns } = this.props;
    const allColumns = fb_columns(this.props);
    const filterList = savedFilters.filter_list || {};
    const nameSearch = savedFilters.name_search || null;
    const distanceSearch = savedFilters.distance_search || null;
    const distanceWithin = savedFilters.distance_within || null;

    const compactedList = {};
    map(filterList, (v, k) => {
      const column = allColumns.find(f => f.id === k);
      const ransack_filter = get(column, 'ransack_filter');
      const filterType = get(column, 'filterType', '');
      if (ransack_filter && (v || []).length > 0) {
        if (filterType === 'range') {
          if (v[0]) compactedList[ransack_filter] = { ...compactedList[ransack_filter], gte: v[0] };
          if (v[1]) compactedList[ransack_filter] = { ...compactedList[ransack_filter], lte: v[1] };
        } else if (filterType === 'date') {
          if (v[0]) compactedList[ransack_filter] = { ...compactedList[ransack_filter], lte: moment().subtract(v[0], 'year').format('YYYY-MM-DD') };
          if (v[1]) compactedList[ransack_filter] = { ...compactedList[ransack_filter], gte: moment().subtract(v[1], 'year').format('YYYY-MM-DD') };
        } else if (filterType === 'manager') {
          compactedList[ransack_filter] = v.map(i => i.id);
        } else if (filterType === 'text') {
          compactedList[ransack_filter] = { ...compactedList[ransack_filter], like: v };
        } else if (filterType === 'text_not') {
          compactedList[ransack_filter] = { notLike: v };
        } else if (filterType === 'multiselect_text') {
          compactedList[ransack_filter] = { ...compactedList[ransack_filter], not: v };
        } else if (filterType === 'user_email_exclude') {
          const emails = Array.isArray(v) ? v.map(item => item.email || item.value || item) : [];
          if (emails.length > 0) compactedList[ransack_filter] = { ...compactedList[ransack_filter], not: emails };
        } else {
          compactedList[ransack_filter] = v;
        }
      }
    });

    loadInventoryUserList({ filterList, nameSearch, distanceSearch, distanceWithin });
    this.setState({ compactedList, filterParams: compactedList });
    this.changePage(0, refetch, null, null, filterList, nameSearch || '####NONE####', compactedList, distanceSearch || '####NONE####', distanceWithin || '####NONE####');
  };

  handleSnackOpen = snackMessage => {
    const { enqueueSnackbar } = this.props;
    enqueueSnackbar(snackMessage, {
      variant      : 'default',
      anchorOrigin : {
        vertical   : 'top',
        horizontal : 'center',
      },
    });
  };

  render () {
    const {
      classes,
      deleteInventoryUser,
      inventory_users,
      addInventoryUser,
      updateInventoryUser,
      inventory_user,
      putInventoryUser,
      updateSelectedInventoryUser,
      loadBenchUsers,
      data,
      refetch,
      loadInventoryUserList,
      mutate,
      onlyUsers,
      filterColumns,
      fb_columns,
      currentUserIsAdmin,
      currentUserId,
      loading,
      tags,
      agencies,
      bulkEditItems,
      loadBulkItemsList,
      company,
      allFeatures,
    } = this.props;
    const { countryForCompany, agentWordForCompany, availableProducts } = data;
    const { openSnackBar, snackMessage } = this.state;
    const params = qs.parse(this.props.location.search);

    if (!inventory_users.filterList && inventory_users.loaded) {
      const filterList = {};
      filterColumns(this.props).forEach(c => (filterList[c.id] = []));

      const fbColumns = fb_columns({ company: get(data, 'getCurrentUser.company', {}), data: data, ...this.props });
      const columnNames = fbColumns.map(col => col.id);
      const compactedList = {};

      if (params) {
        Object.keys(params).forEach(key => {
          if (columnNames.includes(key)) {
            compactedList[key] = [ params[key] ];
          }
        });
      }

      loadInventoryUserList({ filterList: {...filterList, ...compactedList} });
      console.log('fl', compactedList);
      this.setState({compactedList: compactedList}, () => {
        refetch({
          limit      : inventory_users.rowsPerPage,
          offset     : inventory_users.page * inventory_users.rowsPerPage,
          orderBy    : inventory_users.orderBy,
          order      : inventory_users.order,
          filterList : compactedList,
        }).then(response => {
          if (response.data && response.data.getInventoryUsers) {
            loadInventoryUserList({
              data        : response.data.getInventoryUsers,
              page        : inventory_users.page,
              rowsPerPage : inventory_users.rowsPerPage,
              orderBy     : inventory_users.orderBy,
              order       : inventory_users.order,
              filterList  : compactedList,
              count       : response.data.getInventoryUserCount || 0,
            });
          }
        }).catch(err => {
          console.error('init refetch error:', err);
        });
      });


    }
    const { inv_user } = params;
    if (inventory_users.error && !openSnackBar && inventory_users.error !== snackMessage) {
      this.handleSnackOpen(inventory_users.error);
    }
    const companyFeatureTypes = Array.isArray(company?.feature_types) ? company.feature_types : [];
    const emailPlatformInventoryUserEnabled = companyFeatureTypes.includes('email_platform_inventory_user_enabled');
    const showEmailPlatformActions = !!onlyUsers || emailPlatformInventoryUserEnabled;

    return (
      <Grid>
        <Paper className={classes.root}>
          <div className={classes.tableWrapper}>
            <ApolloConsumer>
              {client => (
                <div>
                  <LoadCard
                    client={client}
                    user={inv_user || ''}
                    updateSelectedInventoryUser={updateSelectedInventoryUser}
                    InventoryUserQuery={InventoryUserQuery}
                    changeRowsPerPage={this.changeRowsPerPage}
                    onFilterChange={this.onFilterChange}
                    filterList={inventory_users.filterList}
                    onDelete={deleteInventoryUser}
                    onSearch={this.onSearchChange}
                    onDistanceSearch={this.onDistanceSearch}
                    allColumns={fb_columns(this.props)}
                    allowDelete={!onlyUsers}
                    bulkEditDialog={props => (
                      <div style={{ float: 'left' }}>
                        {showEmailPlatformActions && (
                          <>
                            <InventoryUserSendEmailDialog
                              {...props}
                              data={inventory_users.data}
                              loadBulkItemsList={loadBulkItemsList}
                              sendToInventoryUserEmails={!onlyUsers}
                            />
                            <AddToSequenceDialog
                              data={inventory_users.data}
                              selected={props.selected}
                              loadBulkItemsList={loadBulkItemsList}
                              filterParams={this.state.compactedList}
                              inventoryUsersState={inventory_users}
                              totalFilteredCount={inventory_users.count || 0}
                              onlyUsers={!!onlyUsers}
                            />
                          </>
                        )}
                        {onlyUsers && (
                          <span>
                            <InventoryUserMakeManagerDialog
                              {...props}
                              data={inventory_users.data}
                              managers={inventory_users.managers}
                              loadBulkItemsList={loadBulkItemsList}
                              changePage={(e, page) => {
                                this.changePage(inventory_users.page, refetch);
                              }}
                            />
                            <InventoryUserHideUserDialog
                              {...props}
                              data={inventory_users.data}
                              managers={inventory_users.managers}
                              loadBulkItemsList={loadBulkItemsList}
                              changePage={(e, page) => {
                                this.changePage(inventory_users.page, refetch);
                              }}
                            />
                          </span>
                        )}
                      </div>
                    )}
                    updateColumns={(list, value) => {
                      const allCols = fb_columns(this.props);
                      const visibleList = list.filter(id => {
                        const col = allCols.find(c => c.id === id);
                        return !col || !col.hideColumn;
                      });
                      var vars = {};
                      if(onlyUsers) {
                        vars = { default_user_columns : visibleList }
                      } else {
                        vars = { default_inventory_user_columns: visibleList }
                      }
                      mutate({
                        variables : vars,
                      }).then(() => {
                        const fl = inventory_users.filterList;
                        if (fl[value]) {
                          delete fl[value];
                        } else {
                          fl[value] = [];
                        }
                        loadInventoryUserList({
                          selectedColumns : list,
                          filterList      : fl,
                        });
                        this.changePage(inventory_users.page, refetch, null, null, fl);
                      });
                    }}
                  />
                  {onlyUsers && (
                    <SavedFilterSetSelector
                      filterContext="user_admin"
                      currentFilterList={inventory_users.filterList}
                      nameSearch={inventory_users.nameSearch}
                      distanceSearch={inventory_users.distanceSearch}
                      distanceWithin={inventory_users.distanceWithin}
                      onApplyFilterSet={this.handleApplyFilterSet}
                    />
                  )}
                  <MuiThemeProvider theme={tableTheme}>
                    <FBTable
                      data={inventory_users.data || []}
                      tags={tags}
                      order={inventory_users.order}
                      orderBy={inventory_users.orderBy}
                      count={inventory_users.count}
                      selected={inventory_users.selected}
                      page={inventory_users.page}
                      offset={inventory_users.offset}
                      rowsPerPage={inventory_users.rowsPerPage}
                      columns={filterColumns(this.props)}
                      onSort={this.onSort}
                      changePage={(e, page) => {
                        this.changePage(page, refetch);
                      }}
                      rowClick={this.rowClick}
                      client={client}
                      changeRowsPerPage={this.changeRowsPerPage}
                      onFilterChange={this.onFilterChange}
                      filterList={inventory_users.filterList}
                      onDelete={deleteInventoryUser}
                      onSearch={this.onSearchChange}
                      onDistanceSearch={this.onDistanceSearch}
                      allColumns={fb_columns(this.props)}
                      allowDelete={!onlyUsers}
                      loading={loading}
                      exportToCSVButton={props => (
                        <span>
                          <ExportToCSVButton
                            inventory_users={inventory_users}
                            {...props}
                            filterList={this.state.compactedList}
                          />
                        </span>
                      )}
                      currentUserIsAdmin={currentUserIsAdmin}
                      bulkEditItems={bulkEditItems}
                      loadBulkItemsList={loadBulkItemsList}
                      bulkEditDialog={props => (
                        <div style={{ float: 'left' }}>
                          {showEmailPlatformActions && (
                            <>
                              <InventoryUserSendEmailDialog
                                {...props}
                                data={inventory_users.data}
                                loadBulkItemsList={loadBulkItemsList}
                                sendToInventoryUserEmails={!onlyUsers}
                              />
                              <AddToSequenceDialog
                                data={inventory_users.data}
                                selected={props.selected}
                                loadBulkItemsList={loadBulkItemsList}
                                filterParams={this.state.compactedList}
                                inventoryUsersState={inventory_users}
                                totalFilteredCount={inventory_users.count || 0}
                                onlyUsers={!!onlyUsers}
                              />
                            </>
                          )}
                          {onlyUsers && (
                            <span>
                              <InventoryUserMakeManagerDialog
                                {...props}
                                data={inventory_users.data}
                                managers={inventory_users.managers}
                                loadBulkItemsList={loadBulkItemsList}
                                changePage={(e, page) => {
                                  this.changePage(inventory_users.page, refetch);
                                }}
                              />
                              <InventoryUserHideUserDialog
                                {...props}
                                data={inventory_users.data}
                                managers={inventory_users.managers}
                                loadBulkItemsList={loadBulkItemsList}
                                changePage={(e, page) => {
                                  this.changePage(inventory_users.page, refetch);
                                }}
                              />
                              <InventoryUserObfuscateUserDialog
                                {...props}
                                data={inventory_users.data}
                                managers={inventory_users.managers}
                                loadBulkItemsList={loadBulkItemsList}
                                changePage={(e, page) => {
                                  this.changePage(inventory_users.page, refetch);
                                }}
                              />
                              <InventoryUserAssignAsLimitedAccess
                                {...props}
                                data={inventory_users.data}
                                managers={inventory_users.managers}
                                loadBulkItemsList={loadBulkItemsList}
                                changePage={(e, page) => {
                                  this.changePage(inventory_users.page, refetch);
                                }}
                              />
                              {currentUserIsAdmin && (
                                <InventoryUserResendActivationEmail
                                  {...props}
                                  data={inventory_users.data}
                                  managers={inventory_users.managers}
                                  loadBulkItemsList={loadBulkItemsList}
                                  changePage={(e, page) => {
                                    this.changePage(inventory_users.page, refetch);
                                  }}
                                />
                              )}
                              <InventoryUserOmitFromMkt
                                {...props}
                                data={inventory_users.data}
                                managers={inventory_users.managers}
                                loadBulkItemsList={loadBulkItemsList}
                                changePage={(e, page) => {
                                  this.changePage(inventory_users.page, refetch);
                                }}
                              />
                            </span>
                          )}
                        </div>
                      )}
                      updateColumns={(list, values) => {
                        const allCols = fb_columns(this.props);
                        const visibleList = list.filter(id => {
                          const col = allCols.find(c => c.id === id);
                          return !col || !col.hideColumn;
                        });
                        var vars = {};
                        if(onlyUsers) {
                          vars = { default_user_columns: visibleList }
                        } else {
                          vars = { default_inventory_user_columns: visibleList }
                        }
                        mutate({
                        variables : vars,
                        }).then(() => {
                          const fl = inventory_users.filterList;
                          for (let i = 0; i < values.length; i += 1) {
                            if (fl[values[i]]) {
                              delete fl[values[i]];
                            } else {
                              fl[values[i]] = [];
                            }
                          }
                          loadInventoryUserList({
                            selectedColumns : list,
                            filterList      : fl,
                          });
                          this.changePage(inventory_users.page, refetch, null, null, fl);
                        });
                      }}
                    />
                  </MuiThemeProvider>
                </div>
              )}
            </ApolloConsumer>
            <InventoryUserDrawer
              inventoryUser={inventory_user.user}
              inventory_users={inventory_users}
              updateAction={updateSelectedInventoryUser}
              updateInventoryUser={updateInventoryUser}
              company={company}
              showBench
              showEditButton
              loadBenchUsers={loadBenchUsers}
              inviteButton={this.inviteButton}
              country={get(company, 'country')}
              openSnack={() => {
                this.handleSnackOpen('User Updated');
              }}
              agentWordForCompany={agentWordForCompany}
              currentUserIsAdmin={currentUserIsAdmin}
              currentUserId={currentUserId}
              refetch={refetch}
              tags={tags}
              agencies={agencies}
              allFeatures={allFeatures}
            />
            <NewFormDialog
              onlyUsers={onlyUsers}
              agentWordForCompany={agentWordForCompany}
              action={addInventoryUser}
              close={inventory_users.close}
              error={inventory_users.error}
              country={get(company, 'country')}
              availableProducts={availableProducts || '[]'}
            />
            <Button
              mini
              color="primary"
              aria-label="add"
              disabled={(inventory_users.data || []).length < 1}
              onClick={() => this.updateModifiedEmails(inventory_users, putInventoryUser)}
            />
          </div>
        </Paper>
      </Grid>
    );
  }
}

InventoryUsers.propTypes = {
  classes                     : PropTypes.object.isRequired,
  inventory_user              : PropTypes.object.isRequired,
  inventory_users             : PropTypes.object.isRequired,
  data                        : PropTypes.object.isRequired,
  intl                        : PropTypes.object.isRequired,
  tags                        : PropTypes.object.isRequired,
  loadInventoryUserList       : PropTypes.func.isRequired,
  putInventoryUser            : PropTypes.func.isRequired,
  deleteInventoryUser         : PropTypes.func.isRequired,
  addInventoryUser            : PropTypes.func.isRequired,
  updateInventoryUser         : PropTypes.func.isRequired,
  updateSelectedInventoryUser : PropTypes.func.isRequired,
  loadBenchUsers              : PropTypes.func.isRequired,
  mutate                      : PropTypes.func.isRequired,
  fb_columns                  : PropTypes.func.isRequired,
  filterColumns               : PropTypes.func.isRequired,
  currentUserIsAdmin          : PropTypes.bool.isRequired,
  loading                     : PropTypes.bool.isRequired,
  onlyUsers                   : PropTypes.bool.isRequired,
  enqueueSnackbar             : PropTypes.func.isRequired,
  refetch                     : PropTypes.func.isRequired,
  agencies                    : PropTypes.array.isRequired,
  bulkEditItems               : PropTypes.array.isRequired,
  loadBulkItemsList           : PropTypes.func.isRequired,
  currentUserId               : PropTypes.number.isRequired,
};

const styles = theme => ({
  title         : {
    fontSize : 18,
    color    : '#fff',
  },
  chip          : {
    margin : '2px',
  },
  invite        : {
    width       : '90px',
    display     : 'block',
    paddingLeft : 15,
  },
  avatar        : {
    height      : 30,
    width       : 30,
    display     : 'inline-flex',
    marginRight : 4,
    fontSize    : 10,
  },
  avatarText    : {
    textTransform : 'uppercase',
  },
  nameField     : {
    display    : 'inline-flex',
    alignItems : 'center',
  },
  iconContainer : {
    minWidth : 60,
  },
  error         : {
    backgroundColor : '#d32f2f',
  },
  default       : {
    backgroundColor : '#333',
  },
});

export default flowRight(graphql(HomeOfficeQuery), graphql(UpdateCurrentUserColumns))(
  injectIntl(withStyles(styles)(withSnackbar(InventoryUsers)))
);
